import { QueryClient } from '@tanstack/react-query';
import { OfflineError } from '@/api/client';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            // Skip retry when the request never even left the device — the
            // axios offline guard throws synchronously, so a retry can't
            // succeed without the user reconnecting first. Retrying just
            // delays the error message by the backoff window. Other errors
            // (5xx, transient network) still get one retry.
            retry: (failureCount, error) => {
                if (error instanceof OfflineError) return false;
                return failureCount < 1;
            },
        },
    },
});
